import { isEmpty as a } from "lodash-es";
import * as s from "yup";
function o(e) {
  return {
    fullAddress: e,
    postCode: e,
    state: e,
    suburb: e
  };
}
function d(e) {
  return {
    fullAddress: e,
    postCode: e,
    state: e,
    suburb: e
  };
}
const f = {
  summaryData: {
    label: "",
    value: ""
  },
  fullDetails: { id: "", fullAddress: "", postCode: "", state: "", suburb: "" }
}, b = (e) => ({
  fullDetails: o(e),
  /**
   * This can be of OptionType/number/string, hence we store a single boolean value in it for consistency across all different cases
   */
  summaryData: e
}), m = (e) => ({
  fullDetails: d(e),
  summaryData: e
}), p = {
  info: {
    basic: "",
    full: {
      fullAddress: "",
      postCode: "",
      state: "",
      suburb: ""
    }
  },
  country: ""
}, h = (e) => ({
  country: e,
  info: {
    basic: e,
    full: {
      fullAddress: e,
      postCode: e,
      state: e,
      suburb: e
    }
  }
}), A = (e) => ({
  overseas: {
    country: e,
    info: {
      basic: e,
      full: {
        fullAddress: e,
        postCode: e,
        state: e,
        suburb: e
      }
    }
  }
}), l = (e) => a(e.fullDetails.id) && !a(e.fullDetails.fullAddress) && !a(e.fullDetails.postCode) && !a(e.fullDetails.state) && !a(e.fullDetails.suburb), n = s.object().shape({
  fullAddress: s.string().required("Please enter a valid street address or PO Box."),
  postCode: s.string().required("Please enter a 4-digit postcode.").min(4, "Please enter a 4-digit postcode."),
  state: s.string().required("Please select a State/Territory."),
  suburb: s.string().required("Please enter a valid suburb.")
}), i = s.object().shape({
  fullDetails: n,
  summaryData: s.mixed().test(
    "emptyValue",
    "Please enter a valid street address or PO Box.",
    function(t) {
      const r = this.parent;
      return l(r) ? !0 : t ? !a(t.label) : !1;
    }
  ).test(
    "no value selected from drop down",
    "Please choose an address from the suggestions that appear below the address field. If you can't see your address listed, choose the last option and enter your address manually.",
    function(t) {
      const r = this.parent;
      return l(r) ? !0 : t ? !a(t.label) && !a(t.value) : !1;
    }
  )
}), g = s.object().shape({
  home: i,
  postal: i
}), u = (e) => s.object().shape({
  country: s.string().required("We can’t help you without this information."),
  info: s.object().shape({
    basic: e === "Basic" ? s.string().required(
      "Please enter a valid street address or PO Box. We need this information to continue."
    ) : s.mixed().notRequired(),
    full: e === "Full" ? n : s.mixed().notRequired()
  })
}), v = (e) => s.object().shape({
  local: s.mixed().when("isOverseasAddress", {
    is: (t) => !!t,
    then: () => s.mixed().notRequired(),
    otherwise: () => i
  }),
  isOverseasAddress: s.bool().notRequired(),
  overseas: s.mixed().when("isOverseasAddress", {
    is: (t) => !!t,
    then: () => u(e),
    otherwise: () => s.mixed().notRequired()
  })
});
export {
  i as addressDataSchema,
  n as fullAddressSchema,
  A as initialOverseasAddressErrors,
  h as initialOverseasAddressTouched,
  p as initialOverseasAddressValues,
  m as initialSingleAddressErrors,
  b as initialSingleAddressTouched,
  f as initialSingleAddressValues,
  l as isManualAddress,
  g as multiAddressSchema,
  v as overseasAddressSchema,
  u as overseasDataSchema
};
